const getKeyName = (key) => `@facturoo'_${key}`;

const stateKey = getKeyName('state');


export const loadState = () => {
  const serializedState = localStorage.getItem(stateKey);
  const state = serializedState ? JSON.parse(serializedState) : {};

  return state;
};

export const saveState = (state) => {
  const serializedState = JSON.stringify({
    app: {
      accessToken: state.app.accessToken,
      empresa: state.app.empresa,
      usuario: state.app.usuario,
      sideMenuOpen: state.app.sideMenuOpen,
    },
  });

  localStorage.setItem(stateKey, serializedState);
};
